import React from "react";
import {
  Box,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { Controller } from "react-hook-form";

export const Step3 = (props) => {
  const { register, errors, control } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">Características del lugar afectado</Typography>
      <FormControl
        fullWidth
        sx={{ mb: 2 }}
        required
        error={!!errors.tipoInmueble}
      >
        <Typography variant="subtitle1">
          Selecciona el tipo de inmueble
        </Typography>
        <Controller
          name="tipoInmueble"
          control={control}
          rules={{ required: "El tipo de inmueble es obligatorio" }}
          render={({ field }) => (
            <Select
              {...field}
              value={field.value || ""}
              label="Tipo de inmueble"
            >
              <MenuItem value="Vivienda">Vivienda</MenuItem>
              <MenuItem value="Local">Local</MenuItem>
              <MenuItem value="Comercio">Comercio</MenuItem>
              <MenuItem value="Pyme">Pyme</MenuItem>
              <MenuItem value="Otro">Otro</MenuItem>
            </Select>
          )}
        />
        {errors.tipoInmueble && (
          <Typography color="error">{errors.tipoInmueble?.message}</Typography>
        )}
      </FormControl>

      <TextField
        {...register("metrosCuadrados", {
          required: "Los metros cuadrados son obligatorios",
        })}
        label="Metros cuadrados"
        type="number"
        fullWidth
        required
        sx={{ mb: 2 }}
        error={!!errors.metrosCuadrados}
        helperText={errors.metrosCuadrados?.message}
      />

      <TextField
        {...register("alturaInmueble", {
          required: "La altura del inmueble es obligatoria",
        })}
        label="Altura del inmueble (en metros)"
        type="number"
        fullWidth
        required
        sx={{ mb: 2 }}
        error={!!errors.alturaInmueble}
        helperText={errors.alturaInmueble?.message}
      />

      <TextField
        {...register("numeroEstancias", {
          required: "El número de estancias es obligatorio",
        })}
        label="Número de estancias y uso"
        placeholder="Ej: 3 dormitorios, 2 baños, 1 cocina, 1 salón"
        fullWidth
        required
        multiline
        minRows={4}
        sx={{ mb: 2 }}
        error={!!errors.numeroEstancias}
        helperText={errors.numeroEstancias?.message}
      />
    </Box>
  );
};

export default Step3;
